<app-property-people [prop]="prop"></app-property-people>
